<template>
    <!-- the best game of the player in every stat: a card each, the match a click away -->
    <section class="cl-section records">
        <section-heading title="Ρεκόρ" icon="mdi-medal-outline" />
        <div class="records__grid">
            <article
                v-for="(record, index) in items"
                :key="record.key"
                class="record"
                :class="{ 'record--lead': index < 3, 'record--empty': !record.value }"
                @click="openMatch(record)"
            >
                <div class="record__head">
                    <v-icon small class="record__icon">{{ record.icon }}</v-icon>
                    <span class="record__label">{{ record.label }}</span>
                </div>
                <div class="record__value">{{ record.value || 0 }}</div>
                <div v-if="record.value" class="record__match">
                    <span v-if="record.opponentLogo" class="cl-logo record__logo"><img :src="`${assetsUrl}/${record.opponentLogo}`" alt=""></span>
                    <span class="record__match-text">
                        <span class="record__opponent">vs {{ record.opponent }}</span>
                        <span class="record__date">{{ formatDate(record.date) }}</span>
                    </span>
                    <v-icon small class="record__go">mdi-chevron-right</v-icon>
                </div>
                <div v-else class="record__none">Δεν υπάρχει ακόμη</div>
            </article>
        </div>
    </section>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    import SectionHeading from '@/components/SectionHeading'

    const RECORDS = [
        { key: 'points', label: 'Πόντοι', icon: 'mdi-basketball' },
        { key: 'rebounds', label: 'Ριμπάουντ', icon: 'mdi-arrow-collapse-up' },
        { key: 'assists', label: 'Ασίστ', icon: 'mdi-hand-pointing-right' },
        { key: 'twoPointsMade', label: 'Εύστοχα δίποντα', icon: 'mdi-numeric-2-circle-outline' },
        { key: 'threePointsMade', label: 'Εύστοχα τρίποντα', icon: 'mdi-numeric-3-circle-outline' },
        { key: 'freeThrowsMade', label: 'Εύστοχες βολές', icon: 'mdi-target' },
        { key: 'steals', label: 'Κλεψίματα', icon: 'mdi-hand-back-left-outline' },
        { key: 'blockedShots', label: 'Τάπες', icon: 'mdi-hand-back-right-off-outline' },
        { key: 'turnovers', label: 'Λάθη', icon: 'mdi-swap-horizontal' }
    ]

    export default {
        components: { SectionHeading },
        props: {
            stats: {
                type: Object,
                default: null
            },
            team: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            items() {
                return RECORDS.map(record => {
                    const stat = (this.stats && this.stats[record.key]) || {}
                    return {
                        ...record,
                        value: stat.value,
                        opponent: stat.oponnent,
                        opponentLogo: stat.oponnentLogo,
                        date: stat.date,
                        matchId: stat.matchId
                    }
                })
            }
        },
        methods: {
            formatDate(date) {
                return date ? momentTimezone(date).tz('Europe/Athens').locale('el').format('D MMMM YYYY') : ''
            },
            openMatch(record) {
                if (record.matchId) this.$router.push({ name: 'Match', params: { id: record.matchId } })
            }
        }
    }
</script>

<style scoped>
.records__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.record {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px 16px 14px;
    border-radius: 12px;
    background: #232323;
    color: #fff;
    box-shadow: 0 6px 20px rgba(35, 35, 35, 0.12);
    font-family: Roboto, Arial, sans-serif;
    text-align: left;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.15s, box-shadow 0.15s;
}

.record:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 26px rgba(3, 122, 222, 0.2);
}

.record::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #03e5b7 0%, #037ade 100%);
    opacity: 0.5;
}

/* points, rebounds and assists first, a little brighter */
.record--lead {
    background:
        radial-gradient(circle at 100% 0%, rgba(3, 229, 183, 0.18) 0%, rgba(3, 229, 183, 0) 55%),
        #232323;
}

.record--lead::before {
    opacity: 1;
}

.record--empty {
    cursor: default;
}

.record--empty .record__value,
.record--empty .record__label {
    color: rgba(255, 255, 255, 0.35);
}

.record--empty:hover {
    transform: none;
}

.record__head {
    display: flex;
    align-items: center;
    gap: 6px;
}

.record__icon {
    color: #03e5b7 !important;
}

.record__label {
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.7);
}

.record__value {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 3rem;
    line-height: 1;
}

.record--lead .record__value {
    background-image: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.record__match {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.record__logo {
    width: 28px;
    height: 28px;
}

.record__match-text {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.2;
}

.record__opponent {
    font-size: 0.85rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record__date {
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.55);
}

.record__go {
    color: rgba(255, 255, 255, 0.35) !important;
}

.record:hover .record__go {
    color: #03e5b7 !important;
}

.record__none {
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 900px) {
    .records__grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
    }

    .record {
        padding: 12px 12px 10px;
    }

    .record__value {
        font-size: 2.4rem;
    }
}

@media (max-width: 420px) {
    .records__grid {
        grid-template-columns: 1fr;
    }
}
</style>
